import { I18nPluralPipe } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { NowCarousel } from '@now/dpl';
import { BildungsangebotTerminDetail } from '../../../../model';
import { BildungsanbieterComponent } from '../detail-inhalt/bildungsanbieter/bildungsanbieter.component';
import { DetailKachelComponent } from '../detail-kachel/detail-kachel.component';
import { KontaktSliderKachelComponent } from './kontakt-slider-kachel/kontakt-slider-kachel.component';

@Component({
  selector: 'now-wbsuche-lib-tab-anbieter',
  templateUrl: './tab-anbieter.component.html',
  imports: [
    DetailKachelComponent,
    BildungsanbieterComponent,
    KontaktSliderKachelComponent,
    I18nPluralPipe
  ]
})
export class TabAnbieterComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true })
  public termin!: BildungsangebotTerminDetail;

  public collapseStates: {
    bildungsanbieter?: boolean;
    kontaktperson?: boolean;
  } = {};

  @ViewChild('carouselElement')
  public carouselElement: ElementRef<HTMLElement> = {} as ElementRef;

  ngOnDestroy(): void {
    this.carouselElement?.nativeElement?.nowCarousel?.dispose();
  }

  ngAfterViewInit(): void {
    NowCarousel.init(this.carouselElement?.nativeElement);
  }
}
